<template>
  <borrower-form :editable="false" />
</template>

<script>
import BorrowerForm from './Form'

export default {
  name: 'BorrowerShow',
  components: { BorrowerForm },
  metaInfo () {
    return {
      title: this.$t('string.showBorrower'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped>
</style>
